"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsWxClient = getIsWxClient;
exports.getIsAppClient = getIsAppClient;
exports.getIsWeiBoClient = getIsWeiBoClient;
exports.isKaisaGlobalPcClient = isKaisaGlobalPcClient;
exports.getIsIphonex = getIsIphonex;
exports.getSystemTheme = getSystemTheme;
exports.isSetGreenColorWhenStockUp = isSetGreenColorWhenStockUp;
exports.filterString = filterString;
exports.filterEmptyHtmlTag = filterEmptyHtmlTag;
exports.filterStyleProperty = filterStyleProperty;
exports.tableTagAddScrollClassName = tableTagAddScrollClassName;
exports.formatDate = formatDate;
exports.convertStockMarket = convertStockMarket;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.match");

function getIsWxClient() {
  // 判断当前是否是微信环境
  var ua = navigator.userAgent.toLowerCase(); // eslint-disable-next-line eqeqeq

  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }

  return false;
}

function getIsAppClient() {
  // 判断当前是否是app环境
  var u = navigator.userAgent;
  var isApp = !!u.match(/zunaerqjth/); // app端

  return isApp;
}

function getIsWeiBoClient() {
  // 判断当前是否是微博环境
  var ua = navigator.userAgent.toLowerCase();

  if (ua.match(/WeiBo/i)) {
    return true;
  }

  return false;
}
/**
 * 判断程序是否运行于PC端
 */


function isKaisaGlobalPcClient() {
  return !!navigator.userAgent.match(/kaisaglobalpc/);
}

function getIsIphonex() {
  if (typeof window !== 'undefined' && window) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return isiOS && window.screen.height >= 812;
  }

  return false;
}

function getSystemTheme() {
  // 判断当前的皮肤模式
  var lightReg = /\?theme=light/;
  var darkReg = /\?theme=dark/;
  var u = navigator.userAgent;
  var light = !!u.match(lightReg);
  var dark = !!u.match(darkReg);

  if (light) {
    return 'light';
  }

  if (dark) {
    return 'dark';
  }

  return '';
}
/**
 * 判断是否设置为绿涨红跌
 * 根据UserAgent中的upanddown的值来判断，1代表红涨绿跌，2代表绿涨红跌
 * @returns 
 */


function isSetGreenColorWhenStockUp() {
  return !!navigator.userAgent.match(/"upanddown":2/);
}
/*
* filterList: Array<string> 需要过滤的字符列表
* content: string 待过滤的文本
*/


function filterString(filterList, content) {
  content = content || '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = filterList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var keyword = _step.value;
      // 将正则表达式中的元字符进行转义
      keyword = keyword.replace(/([\\*\\.\\?\\+\\$\\^\\[\\(\\{\\|\\}\\)\\/\]])/g, '\\$1');
      var REGEXP = new RegExp(keyword, 'gi');
      content = content.replace(REGEXP, '');
    } // 过滤掉连续三个及以上的？

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  content = content.replace(/\?{3,}/g, '');
  return content;
}
/**
 *
 * @param {string} domStr 待清除空html标签的html字符串
 */


function filterEmptyHtmlTag(domStr) {
  var result = domStr;
  var filterResult = domStr;
  var emptyHtmlTagRegExp = /<([a-z]+)([^>]*?)>(\s)*<\/\1>/g;

  do {
    result = result.replace(emptyHtmlTagRegExp, '');
    filterResult = result.replace(emptyHtmlTagRegExp, '');
  } while (result !== filterResult);

  return result;
}
/**
 *
 * @param {string} domStr 待清除style属性的html字符串
 */


function filterStyleProperty(domStr) {
  return domStr.replace(/style="[^"]*?"/g, '');
}
/**
 *
 * @param {string} domStr 待添加滚动类名的的html字符串
 */


function tableTagAddScrollClassName(domStr) {
  domStr = domStr.replace(/<table/g, '<div class="scroll">' + '<table').replace(/<\/table>/g, '</table></div>');
  return domStr;
}

function formatDate(dateString) {
  if (typeof dateString !== 'string') {
    return dateString;
  } // ios 不能转化形如'2021-04-16 05:20:00'的日期，需要将`-`替换成`/`


  dateString = dateString.replace(/-/g, '/');
  var currentDate = new Date();
  var date = new Date(dateString);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  month = month > 9 ? month : "0".concat(month);
  day = day > 9 ? day : "0".concat(day);
  hour = hour > 9 ? hour : "0".concat(hour);
  minute = minute > 9 ? minute : "0".concat(minute);
  var currentYear = currentDate.getFullYear();
  var currentMonth = currentDate.getMonth() + 1;
  var currentDay = currentDate.getDate(); // eslint-disable-next-line

  if (year == currentYear && month == currentMonth && day == currentDay) {
    return "".concat(hour, ": ").concat(minute);
  }

  return "".concat(month, "-").concat(day, " ").concat(hour, ": ").concat(minute);
}

function convertStockMarket(marketCode) {
  var marketList = [{
    name: '港股',
    code: 'hk'
  }, {
    name: '美股',
    code: 'us'
  }, {
    name: '上证',
    code: 'sh'
  }, {
    name: '深证',
    code: 'sz'
  }, {
    name: '其他',
    code: 'other'
  }];

  for (var _i = 0, _marketList = marketList; _i < _marketList.length; _i++) {
    var market = _marketList[_i];

    if (marketCode === market.code) {
      return market.name;
    }
  }

  return '--';
}